
import "./SubscriptionRequestInstituteForm.scss";
import MaileSvg from "@Assets/svg/Contactus/Maile.svg";
import SupportSvg from "@Assets/svg/Contactus/support.svg";
import LocationSvg from "@Assets/svg/Contactus/Location.svg";
import DeliverySvg from "@Assets/svg/Contactus/Delivery.svg";
import GetinTouchSvg from "@Assets/svg/Contactus/getintouch.svg";
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { InputTextarea } from 'primereact/inputtextarea';
import { useFormik } from "formik";
//import { ContactUsInitialValue, ContactUsSchema } from "./Schema/contactus.schema";
//import { contactUs } from "./service/contactus.service";
import { APIResponse, APIStatus } from "@Src/services/baseInterfaces";
import { useAppDispatch } from "@Src/app/hooks";
import { toast } from "react-hot-toast";
import { showSpinner } from "@Src/app/reducers/globalSlice";
import SvgIcon from '@Components/icons/SvgIcon';
import { useEffect, useRef, useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { getInstituteTypes, postSubscriptionRequest } from "./services/SubscriptionRequest.service";
import { getAllBoardList } from "../Auth/components/exam_prefrences/services/examPrefrences.service";
import * as Yup from "yup";
import ReCAPTCHA from "react-google-recaptcha";
import { RECAPTCHA_SITE_KEY } from "./services/SubscriptionRequest.api.constant";
import { globalRegex } from "@Src/utils/regex/regex.constant";





interface SubscriptionForm {
  InstituteName: string,
  InstituteEmail: string,
  ContactNumber: string,
  ContactPersonName: string,
  InstituteTypeId: number,
  NoOfStudents: string,
  Description: string,
  BoardIds: number[],
  captcha: string,
}
export const SubscriptionRequestInstituteForm = () => {

  const [loading, setLoading] = useState(false);

  const [instituteTypes, setInstituteTypes] = useState<any>([]);
  const [boardList, setBoardList] = useState<any>([]);
  const captchaRef = useRef<any>(null);
  // const { executeRecaptcha } = useGoogleReCaptcha();


  // const [examTypes, setExamTypes] = useState({
  //   neet: false,
  //   iitJee: false,
  //   bitsPilani: false,
  //   cbse: false,
  //   icse: false,
  // });


  // const [instituteName, setInstituteName] = useState("");
  // const [instituteEmailId, setInstituteEmailId] = useState("");
  // const [ContactNumber, setContactNumber] = useState("");
  // const [ContactPerson, setContactPerson] = useState("");
  // const [noOfStudents, setNoOfStudents] = useState("");
  // const [instituteType, setInstituteType] = useState<number>(0);
  // const [subscriptionType, setSubscriptionType] = useState("Subscription Type");
  // const [description, setDescription] = useState("");


  // const handleChange = (
  //   event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  // ) => {
  //   const { name, value, type } = event.target;
  //   console.log(value);

  //   if (type === "checkbox") {
  //     const checked = (event.target as HTMLInputElement).checked;
  //     setExamTypes(prev => ({
  //       ...prev,
  //       [name]: checked,
  //     }));
  //     return;
  //   }

  //   if (name === "instituteName") setInstituteName(value);
  //   if (name === "instituteEmailId") setInstituteEmailId(value);
  //   if (name === "ContactNumber") setContactNumber(value);
  //   if (name === "ContactPerson") setContactPerson(value);
  //   if (name === "noOfStudents") setNoOfStudents(value);
  //   if (name === "instituteType") setInstituteType(Number(value));
  //   if (name === "subscriptionType") setSubscriptionType(value);
  //   if (name === "description") setDescription(value);
  // };

  // const handleBlur = (
  //   event: React.FocusEvent<
  //     HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
  //   >
  // ) => {
  //   const { name, value } = event.target;

  //   // optional: validation logic
  //   console.log(name, value);
  // };

  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();

  //   if (!executeRecaptcha) {
  //     console.log("reCAPTCHA not ready");
  //     return;
  //   }

  //   setLoading(true);

  //   try {
  //     // 🔐 Generate reCAPTCHA token
  //     const recaptchaToken = await executeRecaptcha("contact_form_submit");

  //     const payload = {
  //       instituteName,
  //       instituteEmailId,
  //       ContactNumber,
  //       noOfStudents,
  //       instituteType,
  //       subscriptionType,
  //       description,
  //       examTypes, // your checkbox state
  //       recaptchaToken,
  //     };

  //     await fetch("/api/contact", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(payload),
  //     });

  //     alert("Form submitted successfully");
  //   } catch (error) {
  //     console.error("Submission failed", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  const fetchIntituteTypes = async () => {
    try {
      const response = await getInstituteTypes();
      if (response.ResponseType === "SUCCESS") {
        setInstituteTypes(response.data)

      }

    } catch (error) {
      console.log(error);

    }
  }

  const fetchBoards = async () => {
    try {
      const response = await getAllBoardList();
      if (response.ResponseType === "SUCCESS") {
        setBoardList(response.data)
      }
    } catch (error) {
      console.log(error);

    }
  }

  useEffect(() => {
    fetchIntituteTypes();
    fetchBoards();
  }, [])



  const formik = useFormik<SubscriptionForm>({
    initialValues: {
      InstituteName: "",
      InstituteEmail: "",
      ContactNumber: "",
      ContactPersonName: "",
      InstituteTypeId: 0,
      NoOfStudents: "",
      Description: "",
      BoardIds: [] as number[],
      captcha: "",
    },

    validationSchema: Yup.object({
      InstituteName: Yup.string().required("Institute name is required").max(100, "Institute name must be less than 100 characters"),
      InstituteEmail: Yup.string().email("Email is not in valid format").required("Institute email is required").max(100, "Email must be less than 100 characters"),
      ContactNumber: Yup.string().required("Contact number is required").matches(globalRegex.MOBILE_NUMBER.REGEX, globalRegex.MOBILE_NUMBER.MESSAGE),
      ContactPersonName: Yup.string().required("Contact person name is required").max(100, "Contact person name must be less than 100 characters"),
      InstituteTypeId: Yup.number().required("Institute type is required").test(
        "not-zero",
        "Institute type is required",
        (value) => value !== 0
      ),
      NoOfStudents: Yup.string().required("Number of students is required").matches(globalRegex.ONLY_NUMBER.REGEX, globalRegex.ONLY_NUMBER.MESSAGE),
      Description: Yup.string().required("Description is required"),
      BoardIds: Yup.array().min(1, "Choose at least one board"),
      captcha: Yup.string().required("Please verify captcha"),
    })
    ,

    onSubmit: async (values) => {
      setLoading(true)
      try {
        const payload = {
          BoardIds: values.BoardIds,
          ContactNumber: values.ContactNumber,
          ContactPersonName: values.ContactPersonName,
          Description: values.Description,
          InstituteEmail: values.InstituteEmail,
          InstituteName: values.InstituteName,
          InstituteTypeId: Number(values.InstituteTypeId),
          NoOfStudents: Number(values.NoOfStudents)
        }

        const response = await postSubscriptionRequest(payload);
        toast.success(response.StatusMsg)
        formik.resetForm();
        captchaRef.current.reset()
      } catch (error) {
        console.log(error);
        toast.error("Failed to submit the form");
        captchaRef.current.reset()
      } finally {
        setLoading(false);
      }

    },
  });



  return (
    <>
      <section className="contact-us-section">
        <div className="ia-container">
          <div className="grid justify-content-between">
            <div className="col-12 lg:col-8 py-2">
              <div className="pt-4">
                <div className="flex align-items-center gap-2">
                  <span className="tw-text-purple-700">Home </span> <span><SvgIcon name="rightArrow" size={16} style={{ padding: 0, marginTop: '6px' }} /></span>{" "}
                  <span className="active-span"> Contact Us</span>
                </div>
              </div>
              <div className="text-white pt-3 ml-0">
                <h1>Contact Us</h1>
              </div>
            </div>
            <div className="col-12 lg:col-4 pb-0">
              <img src={require("@Assets/img/cta-banner-img-3.png")} alt="" className="twt-w-full twt-h-full tw-object-cover" />
            </div>
          </div>
        </div>
      </section>

      <section className="ia-container my-4">
        <div className="contact-us tw-bg-white tw-rounded-2xl tw-shadow-lg px-4 py-4">

          <div className="tw-grid tw-grid-cols-2 gap-3 md:gap-6">
            <div className="tw-col-span-2 md:tw-col-span-2">
              <h2>Get in Touch</h2>
              <p>Have questions? Need more details on how to get started? Reach out now for expert assistance.</p>
              <form onSubmit={formik.handleSubmit}>
                <div className="tw-grid tw-grid-cols-2 gap-4 mt-4">
                  <div className="tw-col-span-2 md:tw-col-span-2">
                    <label
                      htmlFor="InstituteName"
                      className="tw-text-sm tw-font-medium tw-text-gray-700"
                    >
                      Institute Name <span className="tw-text-red-500">*</span>
                    </label>
                    <InputText
                      value={formik.values.InstituteName}
                      name="InstituteName"
                      id="InstituteName"
                      className="tw-shadow tw-appearance-none tw-border tw-rounded tw-w-full tw-py-3 px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline"
                      type="text"
                      placeholder="Institute Name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    <br />
                    {formik.touched.InstituteName && formik.errors.InstituteName && (
                      <p className="tw-text-red-500 tw-text-sm ">
                        {formik.errors.InstituteName}
                      </p>
                    )}
                  </div>
                  <div className="tw-col-span-2 md:tw-col-span-2">
                    <label
                      htmlFor="InstituteEmail"
                      className="tw-text-sm tw-font-medium tw-text-gray-700"
                    >
                      Institute Email ID <span className="tw-text-red-500">*</span>
                    </label>
                    <InputText
                      type="text"
                      value={formik.values.InstituteEmail}
                      name="InstituteEmail"
                      id="InstituteEmail"
                      className="tw-shadow tw-appearance-none tw-border tw-rounded tw-w-full tw-py-3 px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline"
                      placeholder="Institute Email id"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    <br />
                    {formik.touched.InstituteEmail && formik.errors.InstituteEmail &&
                      <p className="tw-text-red-500 tw-text-sm">
                        {formik.errors.InstituteEmail}
                      </p>
                    }
                  </div>
                  <div className="tw-col-span-2 md:tw-col-span-2">
                    <label
                      htmlFor="ContactNumber"
                      className="tw-text-sm tw-font-medium tw-text-gray-700"
                    >
                      Contact Number <span className="tw-text-red-500">*</span>
                    </label>

                    <InputText
                      type="text"
                      maxLength={10}
                      minLength={10}
                      value={formik.values.ContactNumber}
                      name="ContactNumber"
                      id="ContactNumber"
                      className="tw-shadow tw-appearance-none tw-border tw-rounded tw-w-full tw-py-3 px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline"
                      placeholder="Contact Number"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      onKeyDown={(e) => {
                        if (
                          !/[0-9]/.test(e.key) &&
                          e.key !== "Backspace" &&
                          e.key !== "ArrowLeft" &&
                          e.key !== "ArrowRight" &&
                          e.key !== "Tab"
                        ) {
                          e.preventDefault();
                        }
                      }}

                    />
                    {formik.touched.ContactNumber && formik.errors.ContactNumber &&
                      <p className="tw-text-red-500 tw-text-sm ">
                        {formik.errors.ContactNumber}
                      </p>
                    }
                  </div>
                  <div className="tw-col-span-2 md:tw-col-span-2">
                    <label
                      htmlFor="ContactPersonName"
                      className="tw-text-sm tw-font-medium tw-text-gray-700"
                    >
                      Contact Person Name <span className="tw-text-red-500">*</span>
                    </label>
                    <InputText
                      value={formik.values.ContactPersonName}
                      name="ContactPersonName"
                      id="ContactPersonName"
                      className="tw-shadow tw-appearance-none tw-border tw-rounded tw-w-full tw-py-3 px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline"
                      placeholder="Contact Person Name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.ContactPersonName && formik.errors.ContactPersonName &&
                      <p className="tw-text-red-500 tw-text-sm ">
                        {formik.errors.ContactPersonName}
                      </p>
                    }
                  </div>
                  <div className="tw-col-span-2 md:tw-col-span-2 tw-relative">
                    <label
                      htmlFor="InstituteTypeId"
                      className="tw-text-sm tw-font-medium tw-text-gray-700"
                    >
                      Select Institute Type <span className="tw-text-red-500">*</span>
                    </label>
                    <select
                      name="InstituteTypeId"
                      value={formik.values.InstituteTypeId}
                      id="InstituteTypeId"
                      className="custom-form-select tw-shadow tw-appearance-none tw-border tw-rounded tw-w-full tw-py-3 tw-px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      <option value={0}>Select Institute Type</option>
                      {
                        instituteTypes.length > 0 ?
                          instituteTypes.map((type: any, index: number) => {
                            return (
                              <option key={index} value={type.Id}>{type.Name}</option>
                            )

                          })
                          : <option value="">No Options Available</option>
                      }

                    </select>
                    <div className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-px-2 tw-text-gray-700">
                      <svg className="tw-fill-current tw-h-4 tw-w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                    </div>
                    {formik.touched.InstituteTypeId && formik.errors.InstituteTypeId &&
                      <p className="tw-text-red-500 tw-text-sm ">
                        {formik.errors.InstituteTypeId}
                      </p>
                    }
                  </div>
                  <div className="tw-col-span-2 md:tw-col-span-2">
                    <label
                      htmlFor="noOfStudents"
                      className="tw-text-sm tw-font-medium tw-text-gray-700"
                    >
                      No. of Students you want to enroll <span className="tw-text-red-500">*</span>
                    </label>
                    <InputText
                      type="text"
                      value={formik.values.NoOfStudents}
                      name="NoOfStudents"
                      id="NoOfStudents"
                      className="tw-shadow tw-appearance-none tw-border tw-rounded tw-w-full tw-py-3 px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline"
                      placeholder="No. of Students you want to enroll"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      onKeyDown={(e) => {
                        if (
                          !/[0-9]/.test(e.key) &&
                          e.key !== "Backspace" &&
                          e.key !== "ArrowLeft" &&
                          e.key !== "ArrowRight"
                        ) {
                          e.preventDefault();
                        }
                      }}
                    />
                    {formik.touched.NoOfStudents && formik.errors.NoOfStudents ? (
                      <p className="tw-text-red-500 tw-text-sm ">
                        {formik.errors.NoOfStudents}
                      </p>
                    ) : null}
                  </div>
                  <div className="tw-col-span-2 md:tw-col-span-2">
                    <p className="tw-font-semibold mb-3">Examinations you're interested in <span className="tw-text-red-500">*</span></p>
                    <div className="institute-type-radio tw-flex tw-gap-4 tw-flex-wrap">
                      {
                        boardList.length > 0 &&
                        boardList.map((board: any, index: any) => {
                          return (
                            <label key={board.Id}>
                              <input
                                type="checkbox"
                                checked={formik.values.BoardIds.includes(board.Id)}
                                onChange={(e) => {
                                  const isChecked = e.target.checked;
                                  const current = formik.values.BoardIds;

                                  formik.setFieldValue(
                                    "BoardIds",
                                    isChecked
                                      ? [...current, board.Id]
                                      : current.filter(v => v !== board.Id)
                                  );

                                  formik.setFieldTouched("BoardIds", true);
                                }}
                                onBlur={formik.handleBlur}
                              />
                              {board.Name}

                            </label>


                          )
                        })
                      }
                      {formik.touched.BoardIds &&
                        formik.errors.BoardIds &&
                        formik.values.BoardIds.length === 0 && (
                          <p className="tw-text-red-500 tw-text-sm ">
                            {formik.errors.BoardIds}
                          </p>
                        )}

                    </div>

                  </div>

                  {/* <div className="tw-col-span-2 md:tw-col-span-1 tw-relative">
                      <select 
                      name="subscriptionType"
                      value={subscriptionType}
                      id="subscriptionType"                      
                      className="custom-form-select tw-block tw-shadow tw-appearance-none tw-border tw-rounded tw-w-full tw-py-3 tw-px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline"
                      onChange={handleChange}
                      >
                        <option value="Subscription Type">Subscription Type</option>
                        <option value="Monthly">Monthly</option>
                        <option value="Quarterly">Quarterly</option>
                        <option value="Annual">Annual</option>
                      </select>
                      <div className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-px-2 tw-text-gray-700">
                        <svg className="tw-fill-current tw-h-4 tw-w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                      </div>
                      {touched.instituteType && errors.instituteType ? (
                        <p className="tw-text-red-500 tw-text-sm ">
                          {errors.instituteType}
                        </p>
                      ) : null}
                    </div> */}
                  <div className="tw-col-span-2">
                    <label
                      htmlFor="Description"
                      className="tw-text-sm tw-font-medium tw-text-gray-700"
                    >
                      Description <span className="tw-text-red-500">*</span>
                    </label>
                    <InputTextarea
                      name="Description"
                      value={formik.values.Description}
                      id="Description"
                      className="tw-shadow tw-appearance-none tw-border tw-rounded tw-w-full tw-py-3 px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline"
                      rows={5}
                      cols={30}
                      placeholder="Type Your Message*"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.Description && formik.errors.Description &&
                      <p className="tw-text-red-500 tw-text-sm ">
                        {formik.errors.Description}
                      </p>
                    }
                  </div>
                  <div className="tw-col-span-2">
                    <ReCAPTCHA
                      ref={captchaRef}
                      sitekey={RECAPTCHA_SITE_KEY}
                      onChange={(value: any) => {
                        formik.setFieldValue("captcha", value);
                      }}
                      onExpired={() => {
                        formik.setFieldValue("captcha", "");
                      }}
                    />
                    {formik.touched.captcha && formik.errors.captcha &&
                      <p className="tw-text-red-500 tw-text-sm ">
                        {formik.errors.captcha}
                      </p>
                    }
                  </div>

                  <div className="tw-col-span-2">
                    <button type="submit" disabled={loading} className="ia-btn ia-btn-primary px-6">
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
            {/* <div className="tw-col-span-2 md:tw-col-span-1">
                <img src={GetinTouchSvg} alt="getintouch-svg" />
              </div> */}
          </div>
        </div>
      </section>
    </>
  );

}